export enum NavigationActionType {
    PUSH,
    POP,
    INIT,
    REPLACE
}

type INIT_ACTION = {
    type: NavigationActionType.INIT;
    routes: string[];
}

type BACK_ACTION = {
    type: NavigationActionType.POP;
}

type GOTO_ACTION = {
    type: NavigationActionType.PUSH;
    route: string;
}

type REPLACE_ACTION = {
    type: NavigationActionType.REPLACE;
    route: string;
}

export type NavigationAction = INIT_ACTION | BACK_ACTION | GOTO_ACTION | REPLACE_ACTION;

const init = (routes: string[]): INIT_ACTION => {
    return {
        type: NavigationActionType.INIT,
        routes
    }
}

const pop = (): BACK_ACTION => {
    return {
        type: NavigationActionType.POP
    }
}

const push = (route: string): GOTO_ACTION => {
    return {
        type: NavigationActionType.PUSH,
        route
    }
}

const replace = (route: string): REPLACE_ACTION => {
    return {
        type: NavigationActionType.REPLACE,
        route
    }
}

export default {
    init,
    push,
    pop,
    replace
}


